var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mask") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.4444444,3 L4.55555556,3 C3.69222222,3 3,3.7 3,4.55555556 L3,15.4444444 C3,16.3 3.69222222,17 4.55555556,17 L15.4444444,17 C16.3,17 17,16.3 17,15.4444444 L17,4.55555556 C17,3.7 16.3,3 15.4444444,3 L15.4444444,3 Z M13.8888889,10.7777778 L10.7777778,10.7777778 L10.7777778,13.8888889 L9.22222222,13.8888889 L9.22222222,10.7777778 L6.11111111,10.7777778 L6.11111111,9.22222222 L9.22222222,9.22222222 L9.22222222,6.11111111 L10.7777778,6.11111111 L10.7777778,9.22222222 L13.8888889,9.22222222 L13.8888889,10.7777778 L13.8888889,10.7777778 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Unit/Plus_rectangle",
    transform: "translate(-3.000000, -3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRectangle);
export default __webpack_public_path__ + "static/media/plus-rectangle.25f33e837d87392410879e66485eb70d.svg";
export { ForwardRef as ReactComponent };